import { render, staticRenderFns } from "./Letrex.vue?vue&type=template&id=0c71159f&scoped=true"
import script from "./Letrex.vue?vue&type=script&lang=js"
export * from "./Letrex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c71159f",
  null
  
)

export default component.exports